// @flow

import './CardGrid.scss'
import * as React from 'react'

export default ({className="", ...props}) => <div className={`CardGrid ${className}`} {...props}/>